import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconChevronUpBold(_a) {
    var colorVariant = _a.colorVariant, size = _a.size;
    var theme = useContext(ThemeContext);
    var color = setColor(theme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("path", { d: "M77.7778 75L91.6667 61.1111L50 19.4444L8.33335 61.1111L22.2222 75L50 47.2222L77.7778 75Z", fill: color })));
}
//# sourceMappingURL=icon.chevron-up-bold.component.js.map